var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBank(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 29,
    viewBox: "0 0 29 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.739258 25.3993H28.1393V28.1393H0.739258V25.3993ZM3.47926 14.4393H6.21926V24.0293H3.47926V14.4393ZM10.3293 14.4393H13.0693V24.0293H10.3293V14.4393ZM15.8093 14.4393H18.5493V24.0293H15.8093V14.4393ZM22.6593 14.4393H25.3993V24.0293H22.6593V14.4393ZM0.739258 7.58926L14.4393 0.739258L28.1393 7.58926V13.0693H0.739258V7.58926ZM14.4393 8.95926C15.1959 8.95926 15.8093 8.34588 15.8093 7.58926C15.8093 6.83264 15.1959 6.21926 14.4393 6.21926C13.6826 6.21926 13.0693 6.83264 13.0693 7.58926C13.0693 8.34588 13.6826 8.95926 14.4393 8.95926Z",
    fill: "#47A1FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBank);
export default __webpack_public_path__ + "static/media/Bank.6ea13636b360570a68202bea54e97a5a.svg";
export { ForwardRef as ReactComponent };